import React,{useState, useEffect, Component} from 'react'; 
import styled from "styled-components"
import LineDivider from '../LineDivider'

const UpArrow = require('../../../../assets/imgs/upArrow.png');
const DownArrow = require('../../../../assets/imgs/downArrow.png');


// {
//     "billeraccountid": "HGA1A125AE0026253343",
//     "billerType": "BILLER",
//     "billerName": "Urban Improvement Trust (UIT) - Bhiwadi",
//     "authenticator": "037121251",
//     "setAutoPay": "true"
// },
// {
//     "billeraccountid": "HGA1A0AB900037778894",
//     "billerType": "BOTH",
//     "billerName": "Idea Postpaid",
//     "authenticator": "7350035143",
//     "cardno": "xxxx xxxx xxxx 7967",
//     "setAutoPay": "false"
//   }
// {
//     "billAmount": "10.00",
//     "billeraccountid": "HGA1A0C5B70037226381",
//     "billerType": "PAYEE",
//     "billerName": "Airtel Prepaid",
//     "authenticator": "9654241952",
//     "cardno": "xxxx xxxx xxxx 7967",
//     "frequency": "Annually",
//     "setAutoPay": "false"
//   }
// let something = 
//     [ 
//         {
//             "billeraccountid": "HGA1A125AE0026253349",
//                 "billerType": "BILLER",
//                 "billerName": "Urban Improvement Trust (UIT) - Bhiwadi",
//                 "authenticator": "037121251",
//                 "setAutoPay": "true"
//         },
//         {
//     "billeraccountid": "HGA1A125AE0026253343",
//     "billerType": "BILLER",
//     "billerName": "Urban Improvement Trust (UIT) - Bhiwadi",
//     "authenticator": "037121251",
//     "setAutoPay": "true"
// },
// {
//     "billeraccountid": "HGA1A0AB900037778894",
//     "billerType": "BOTH",
//     "billerName": "Idea Postpaid",
//     "authenticator": "7350035143",
//     "cardno": "xxxx xxxx xxxx 7967",
//     "setAutoPay": "false"
//   }
  
//       ]
    
const RegisteredBillers = (props) => {

   const {getRegisteredBillers} = props; 
  // const getRegisteredBillers = something;//For testing -> remove this
  //  console.log(getRegisteredBillers);

    const handleCancelButton = () => {

      let inputString = 'Cancel' + "<split>" + 'Cancel';
      window['autosubmit'](inputString);



     ///here

      document.querySelectorAll('.disableBiller').forEach(item=>{

       // console.log(item)
          item.classList.add('disabled');
      })


    }

    

//CSS
    const ButtonCancel=styled.div`  
        width:92%;
        margin:10px auto;
        margin-top: 15px;
        background: #2c387a;
        color: white;
    `
//

  const showSelectedEMIDetail = ()=>{
    return( <div style={{width:"280px"}} className="disableBiller">

    {getRegisteredBillers.map((item,i)=>{
        return(
           
            <RegisteredBillersWrapper key={i}>

                 <RegisteredBillerAccordion id="disableAccordion"
                
                         BillerName={item.billerName}
                         Authenticator={item.authenticator}
                         BillerAccountID={item.billeraccountid}
                         BillerType={item.billerType}
                         SetAutoPay={item.setAutoPay}
                         Authenticator={item.authenticator}
                         Cardno={item.cardno}
                         Frequency={item.frequency}
                         Amount={item.billAmount}
                           
                />
            </RegisteredBillersWrapper>
            )
        })
    }</div>
    );
    }
    return (
        <React.Fragment>
            {showSelectedEMIDetail()}

            {getRegisteredBillers[0].setAutoPay == "false"?null:
             <ButtonCancel className="action-elem" onClick={()=> handleCancelButton()}>Cancel</ButtonCancel>
            
            }
               
        </React.Fragment>
    );
};

    const RegisteredBillersWrapper = styled.div`
        display:flex;
        flex-direction : column;
        margin: 15px 0;
        width: 100%;


       
`
    const PlanRow =styled.div`
        padding-top: 14px;
        padding-left: 14px;
    `

    const PlanLabel = styled.div`
        display: inline-block;
        vertical-align:middle;
        width:40%;
        text-align: left;
    `
    const PlanValue = styled.div`
        display: inline-block; 
        vertical-align:middle; 
        width:60%;
        text-align: right;
        font-weight:600;
        padding-right: 14px; 
    `
//RegisteredBillerAccordion Component

class RegisteredBillerAccordion extends Component{

    constructor(props) {
        super(props);
        this.state = {
         backgroundImage: DownArrow,
         isClicked:false,
         showSummaryDetail:false,
         borderState:'none',
        };

       
  }

    handleClickState =()=>{
        if(this.state.isClicked == false){
                this.setState({
                    isClicked:true,
                    backgroundImage:UpArrow,
                    showSummaryDetail: true
                })
        }else{
            this.setState({
                isClicked:false,
                backgroundImage:DownArrow,
                showSummaryDetail: false
            })
        }
    }

    handleAutoPayButton =(BillerAccountID) => {
        // alert("clicked");
      //  console.log(BillerAccountID)
        let inputString = 'Set Auto Pay' + "<split>" + BillerAccountID;
        window['autosubmit'](inputString);

        document.querySelectorAll('.disableBiller').forEach(item=>{

          //  console.log(item)
              item.classList.add('disabled');
          })



        // document.getElementById(BillerAccountID).style.background="pink";

        this.setState({
            borderState:'2.5px solid #5b669b'
        })
      
    }
   
render(){

    const Summary_mainBlock=styled.div`
        position: relative;
        display:flex;
        flex-direction : column;
        margin: 0px 12px;
        border: 1px solid #fcfcfc;;
        border-radius: 4px;
        box-shadow: 0px 5px 12px rgba(0,0,0,0.2);
        background: #fcfcfc;
    `
    const Summary_titleBlock=styled.div` 

     

        & .billerTitle{
            font-size:14px;
            font-weight: 550;
            padding: 12px;
            padding-bottom: 6px;
            width:220px;
        
        }

        & .billerSubtitle{
            font-size:12px;
            padding: 12px;
            padding-top: 0px;
            padding-left: 14px
            width:220px;

        }

        & .arrowBlock{
            position:absolute;
            top: 16px;
            right:0px;
            height:30px;
            width:30px;
            background: url(${this.state.backgroundImage});
            background-repeat: no-repeat;
            cursor: pointer;
        }
    `
    const Summary_detailBlock=styled.div`
        font-size:12px;
  
    `

    const DashDivider=styled.div`
        border-bottom:1px dashed rgba(102,102,102,0.2);
    `
    const PlanRow =styled.div`
        padding:10px 12px;
   
    `
    const PlanLabel = styled.div`
        display: inline-block;
        vertical-align:middle;
        width:40%;
        text-align: left;
        margin:0px;
    `
    const PlanValue = styled.div`
        display: inline-block; 
        vertical-align:middle; 
        width:60%;
        text-align: right;
        font-weight:600;
       
    `

    const SetAutoPayButton = styled.div `
        // height: 40px;
        // width: auto;
        // background: green;
        // color: white;

    
    
    `

    // "authenticator": "9654241952",
    //"cardno": "xxxx xxxx xxxx 7967",
    //"frequency": "Annually",
//
    return(
        <Summary_mainBlock id="summaryWrapper" style={{border:`${this.state.borderState}`}}>

          
                       
            <Summary_titleBlock >
                    <div className="billerTitle">
                            {this.props.BillerName}  
                    </div>
                    <div className="billerSubtitle">
                            {this.props.Authenticator}  
                    </div>
                    {(this.props.SetAutoPay == 'false' && this.props.Cardno == undefined && this.props.Frequency == undefined && this.props.Amount == undefined)? 
                    null
                    : 
                    <div className="arrowBlock" onClick={() => this.handleClickState()} ></div>
                    }
                  
            </Summary_titleBlock>

            {this.state.showSummaryDetail?
            <Summary_detailBlock>
                <DashDivider/>
                    {this.props.SetAutoPay=="true"? 
                    <div>
                    <PlanRow>
                        <SetAutoPayButton id={this.props.BillerAccountID} className="action-elem" onClick={()=> this.handleAutoPayButton(this.props.BillerAccountID)}>
                            Set Auto Pay
                        </SetAutoPayButton>
                    </PlanRow>
                    </div>   
                    :
                    <div>
                    {this.props.Cardno != undefined?
                    <PlanRow>
                        <PlanLabel>Card No</PlanLabel>
                        <PlanValue>{this.props.Cardno}</PlanValue>
                    </PlanRow>:null}
                    {this.props.Frequency != undefined?
                    <div>
                         <DashDivider/>
                        <PlanRow>
                            <PlanLabel>Frequency</PlanLabel>
                            <PlanValue>{this.props.Frequency}</PlanValue>
                        </PlanRow>
                    </div>:null}
                    {this.props.Amount != undefined?
                    <div>
                         <DashDivider/>
                        <PlanRow>
                            <PlanLabel>Amount</PlanLabel>
                            <PlanValue>{this.props.Amount}</PlanValue>
                        </PlanRow>
                    </div>:null}
                   
                    </div>
                    }
                
              
            </Summary_detailBlock>
            :null}       
        
        </Summary_mainBlock>     
    );
  }
};


export default RegisteredBillers;

